import { takeEvery, call, put, select } from 'redux-saga/effects';
import actionTypes from 'redux/actionTypes';
import {
	getTempatesSuccess,
	getTempatesFailure,
	getCustomAttributeSuccess,
	getCustomAttributeFailure,
	getCustomDatasetDetailsSuccess,
	getCustomDatasetDetailsFailure,
	getSBUDepartmentsFailure,
	getSBUDepartmentsSuccess,
	getSubTempateDetailsSuccess,
	getSubTempateDetailsFailure,
	getCannedReportsSuccess,
	getCannedReportsFailure,
	saveCustomDatasetFailure,
	saveCustomDatasetSuccess,
	getSavedCustomDatasetSuccess,
	getSavedCustomDatasetFailure,
	deleteCustomDatasetSuccess,
	deleteCustomDatasetFailure,
	updateCustomDatasetSuccess,
	updateCustomDatasetFailure
} from './Template.actions';
import APIURLPATH from 'constants/apiconstants';
import { getData } from 'service/getData.service';
import { postData } from 'service/postData.service';
import { putData } from 'service/putData.service';
import { NO_PERSONA, PERSONA } from 'constants/constant';
import { getUpdatedSubTemplateDetails } from 'components/Preview/Preview.utils';
import { logUIError } from 'helper/logging';

export function* getTempatesSaga(request) {
	try {
		const {
			payload: { selectedPersona = NO_PERSONA }
		} = request;
		const tempatesRes = yield call(
			getData,
			`${APIURLPATH.VIEW_TYPE}${selectedPersona}`,
			request.payload
		);

		if (tempatesRes?.statusCode >= 400) {
			throw new Error(tempatesRes?.statusCode);
		}
		const response = tempatesRes?.json;
		response.sort(function (a, b) {
			return a.sortOrder - b.sortOrder;
		});
		yield put(getTempatesSuccess(response));
	} catch (error) {
		yield put(getTempatesFailure(505));
	}
}

export function* getCustomAttributeSaga(request) {
	try {
		const {
			payload: { selectedPersona = NO_PERSONA }
		} = request;
		let tempatesRes = {
			json: [],
			statusCode: 200
		};

		if (selectedPersona === PERSONA.SUPPLIER || selectedPersona === PERSONA.CATMAN) {
			tempatesRes = yield call(
				getData,
				`${APIURLPATH.CUSTOM_ATTRIBUTES_TYPE}${selectedPersona}`,
				request.payload
			);
		}

		if (tempatesRes?.statusCode >= 400) {
			throw new Error(tempatesRes?.statusCode);
		}
		yield put(getCustomAttributeSuccess(tempatesRes?.json));
	} catch (error) {
		yield put(getCustomAttributeFailure(505));
	}
}

export function* getCustomDatasetDetailsSaga(request) {
	let response;
	try {
		const {
			payload: { selectedPersona = NO_PERSONA }
		} = request;

		const url = `${APIURLPATH.CUSTOM_DATASET_DETAILS}${selectedPersona}`;

		response = yield call(getData, url, request.payload);

		if (response?.statusCode >= 400) {
			throw new Error(response?.statusCode);
		}
		const data = response?.json;

		yield put(getCustomDatasetDetailsSuccess(data));
	} catch (error) {
		logUIError(
			request,
			actionTypes.GET_CUSTOM_DATASET_DETAILS,
			`${APIURLPATH.CUSTOM_DATASET_DETAILS}${request.payload?.selectedPersona || NO_PERSONA}`,
			JSON.stringify(request.payload),
			response ? JSON.stringify(response) : 'No response'
		);
		yield put(getCustomDatasetDetailsFailure(505));
	}
}

export function* saveCustomDatasetSaga(request) {
	let response;
	try {
		const datasetName = request.payload.customDatasetName;
		const url = `${APIURLPATH.CUSTOM_DATASET}`;
		response = yield call(postData, url, { requestBody: request.payload });

		if (response?.statusCode >= 400) {
			throw new Error(response?.statusCode);
		}
		const res = response?.json;
		const data = {
			...res,
			templateId: res.customDatasetId,
			cardTitle: res.customDatasetName,
			cardDesc: res.customDatasetDesc
		};

		yield put(saveCustomDatasetSuccess({ data, datasetName }));
	} catch (error) {
		logUIError(
			request,
			actionTypes.SAVE_CUSTOM_DATASET,
			APIURLPATH.CUSTOM_DATASET,
			JSON.stringify({ requestBody: request.payload }),
			response ? JSON.stringify(response) : 'No response'
		);
		yield put(saveCustomDatasetFailure(505));
	}
}

export function* updateCustomDatasetSage(request) {
	let response;
	try {
		const url = `${APIURLPATH.CUSTOM_DATASET}`;
		response = yield call(putData, url, { requestBody: request.payload });

		if (response?.statusCode >= 400) {
			throw new Error(response?.statusCode);
		}
		const res = response?.json;
		const data = {
			...res,
			templateId: res.customDatasetId,
			cardTitle: res.customDatasetName,
			cardDesc: res.customDatasetDesc
		};
		yield put(updateCustomDatasetSuccess(data));
	} catch (error) {
		logUIError(
			request,
			actionTypes.UPDATE_CUSTOM_DATASET,
			APIURLPATH.CUSTOM_DATASET,
			JSON.stringify({ requestBody: request.payload }),
			response ? JSON.stringify(response) : 'No response'
		);
		yield put(updateCustomDatasetFailure(505));
	}
}

export function* deleteCustomDatasetSaga(request) {
	let response;
	try {
		const requestBody = {
			customDatasetId: request.payload.templateId
		};
		const url = `${APIURLPATH.CUSTOM_DATASET_DELETE}`;
		response = yield call(postData, url, { requestBody });

		if (response?.statusCode >= 400) {
			throw new Error(response?.statusCode);
		}
		const data = response?.json.customDatasetId;
		yield put(deleteCustomDatasetSuccess(data));
	} catch (error) {
		logUIError(
			request,
			actionTypes.DELETE_CUSTOM_DATASET,
			APIURLPATH.CUSTOM_DATASET_DELETE,
			JSON.stringify({ requestBody: { customDatasetId: request.payload?.templateId } }),
			response ? JSON.stringify(response) : 'No response'
		);
		yield put(deleteCustomDatasetFailure(505));
	}
}

export function* getSavedCustomDatasetSaga(request) {
	let response;
	try {
		const url = `${APIURLPATH.CUSTOM_DATASET}`;
		response = yield call(getData, url, request.payload);

		if (response?.statusCode >= 400) {
			throw new Error(response?.statusCode);
		}
		const data = response?.json.map((item) => {
			return {
				...item,
				templateId: item.customDatasetId,
				cardTitle: item.customDatasetName,
				cardDesc: item.customDatasetDesc
			};
		});

		yield put(getSavedCustomDatasetSuccess(data));
	} catch (error) {
		logUIError(
			request,
			actionTypes.GET_SAVED_CUSTOM_DATASET,
			APIURLPATH.CUSTOM_DATASET,
			JSON.stringify(request.payload),
			response ? JSON.stringify(response) : 'No response'
		);
		yield put(getSavedCustomDatasetFailure(505));
	}
}

export function* getSBUDepartmentsSaga(request) {
	try {
		const sbus = request.payload.sbu;
		let queryParams = '';
		sbus.map((sbu) => {
			queryParams = `${queryParams}&sbuList=${sbu.toUpperCase()}`;
		});
		queryParams = queryParams.substring(1, queryParams.length);
		const tempatesRes = yield call(
			getData,
			`${APIURLPATH.DEPARTMENT}${queryParams}`,
			request.payload
		);

		if (tempatesRes?.statusCode >= 400) {
			throw new Error(tempatesRes?.statusCode);
		}
		const sbuDepartments = [];
		tempatesRes?.json?.deptDescriptions?.map((item) => {
			sbuDepartments.push({
				deptNum: item.dept_nbr < 10 ? `0${item.dept_nbr}` : item.dept_nbr,
				deptDesc: item.dept_desc
			});
		});
		yield put(getSBUDepartmentsSuccess(sbuDepartments));
	} catch (error) {
		yield put(getSBUDepartmentsFailure(505));
	}
}

export function* getSubTempateDetailsSaga(request) {
	try {
		const {
			payload: { subtemplateId, templateId }
		} = request;

		const response = yield call(
			getData,
			`${APIURLPATH.RUN_QUERY_REQUEST_OBJ}${subtemplateId}&templateId=${templateId}`,
			request.payload
		);

		if (response?.statusCode >= 400) {
			throw new Error(response?.statusCode);
		}
		const calendarRollDim = yield select((state) => state.dashboardReducer.calendarRollDim);
		const updatedResponse = getUpdatedSubTemplateDetails(response?.json, calendarRollDim);
		yield put(getSubTempateDetailsSuccess(updatedResponse));
	} catch (error) {
		yield put(getSubTempateDetailsFailure(505));
	}
}

export function* getCannedReportsSaga(request) {
	try {
		const {
			payload: { selectedPersona = NO_PERSONA }
		} = request;
		const tempatesRes = yield call(
			getData,
			`${APIURLPATH.CANNED_TEMPLATES}${selectedPersona}`,
			request.payload
		);

		if (tempatesRes?.statusCode >= 400) {
			throw new Error(tempatesRes?.statusCode);
		}
		yield put(getCannedReportsSuccess(tempatesRes?.json));
	} catch (error) {
		yield put(getCannedReportsFailure(505));
	}
}

export function* tempatesSagaWatcher() {
	yield takeEvery(actionTypes.GET_TEMPLATES, getTempatesSaga);
	yield takeEvery(actionTypes.GET_CUSTOM_ATTRIBUTE, getCustomAttributeSaga);
	yield takeEvery(actionTypes.GET_SBU_DEPARTMENTS, getSBUDepartmentsSaga);
	yield takeEvery(actionTypes.GET_SUB_TEMPLATE_DETAILS, getSubTempateDetailsSaga);
	yield takeEvery(actionTypes.GET_CANNED_REPORTS, getCannedReportsSaga);
	yield takeEvery(actionTypes.GET_CUSTOM_DATASET_DETAILS, getCustomDatasetDetailsSaga);
	yield takeEvery(actionTypes.SAVE_CUSTOM_DATASET, saveCustomDatasetSaga);
	yield takeEvery(actionTypes.GET_SAVED_CUSTOM_DATASET, getSavedCustomDatasetSaga);
	yield takeEvery(actionTypes.DELETE_CUSTOM_DATASET, deleteCustomDatasetSaga);
	yield takeEvery(actionTypes.UPDATE_CUSTOM_DATASET, updateCustomDatasetSage);
}
